import React from 'react';
import { node } from 'prop-types';
import { Typography } from '@mui/material';

const Title = ({ children }) => (
  <Typography
    variant="h6"
    gutterBottom
    sx={{
      fontSize: '15px',
      fontWeight: '600',
      marginBottom: '15px',
    }}
  >
    {children}
  </Typography>
);
Title.propTypes = {
  children: node.isRequired,
};

export default Title;
